import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    USER: '',
    LANGUAGE: 'cn',
    PAGEMAXINDEX: 0,
    SIDEBARACTIVE: '',
    SIDEBARVUE: null
  },
  mutations: {
    SAVEUSER(state, user) {
      state.USER = user;
      sessionStorage.user = user;
    },
    SAVELANGUAGE(state, language) {
      state.LANGUAGE = language;
      localStorage.language = language;
    },
    SAVEPAGEMAXINDEX(state, pageMaxIndex) {
      state.PAGEMAXINDEX = pageMaxIndex;
      localStorage.pageMaxIndex = pageMaxIndex;
    },
    SAVESIDEBARACTIVE(state, sidebarActive) {
      state.SIDEBARACTIVE = sidebarActive;
    },
    GETSIDEBARVUE(state, vue) {
      state.SIDEBARVUE = vue;
    }
  },
  actions: {
    SAVEUSER(context, user) {
      context.commit('SAVEUSER', user);
    },
    SAVELANGUAGE(state, language) {
      context.commit('SAVELANGUAGE', language);
    },
    SAVEPAGEMAXINDEX(state, pageMaxIndex) {
      context.commit('SAVEPAGEMAXINDEX', pageMaxIndex);
    },
    SAVESIDEBARACTIVE(state, sidebarActive) {
      context.commit('SAVESIDEBARACTIVE', sidebarActive);
    },
    GETSIDEBARVUE(state, vue) {
      context.commit('GETSIDEBARVUE', vue);
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js